import { Building2 } from 'lucide-react';

/*
 * Baylor St. Luke's Main OR rotation. There is no Blackboard folder for this rotation;
 * content comes from the site lead. Until then the page carries the resident's notes.
 */

export const bslmcMainOr = {
  accent: '#2596be',
  icon: Building2,
  tagline: 'Main OR. Content to come from the site lead',
  notesKey: 'notes:st-lukes:main-or',
};
